// extracted by mini-css-extract-plugin
export default {"device_skin":"deviceSkin_device_skin__vEhv4","device_content":"deviceSkin_device_content__knYjF"};